import React from 'react';

// components
import ChatBubble from 'eCoach/ChatBubble';
import DocumentList from 'documentDisplay/components/DocumentList';
import StyledMarkdown from 'shared/StyledMarkdown';

export interface RAGOutput {
  rag: {
    summary: string;
    document_translations: any[];
  };
}

interface RAGCardProps {
  output: RAGOutput;
}

export default function RAGCard({ output }: RAGCardProps): JSX.Element {
  return (
    <ChatBubble>
      <StyledMarkdown content={output.rag.summary} />
      {output.rag.document_translations.length > 0 && (
        <DocumentList documentList={output.rag.document_translations} />
      )}
    </ChatBubble>
  );
}
